const Utils = require('../../../viscomjs/utils/utils');
const doc = document;
const win = window;

const Keyboard = {
    doMove: function (swiper, delta) {

        // Freemode or scrollContainer:
        if (swiper.params.loop) {
            swiper.loopFix();
        }
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        let position = swiper.getTranslate() + delta;

        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
            swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
            clearTimeout(swiper.mousewheel.timeout);
            swiper.mousewheel.timeout = Utils.nextTick(function () {
                swiper.slideToClosest();
            }, 300);
        }

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.stopAutoplay(); }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
    },
    handle: function handle(event) {
        const swiper = this;
        const rtl = swiper.rtlTranslate;
        let e = event;
        if (e.originalEvent) { e = e.originalEvent; } // jquery fix
        const kc = e.keyCode || e.charCode;
        // Directions locks
        if ((!swiper.allowSlideNext || !swiper.shortStepKeyboard.allowSlideNext) && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40)) {
            return false;
        }
        if ((!swiper.allowSlidePrev || !swiper.shortStepKeyboard.allowSlidePrev) && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38)) {
            return false;
        }
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
            return undefined;
        }
        if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
            return undefined;
        }
        const windowWidth = win.innerWidth;
        const windowHeight = win.innerHeight;
        if (swiper.params.shortStepKeyboard.onlyInViewport && (kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents('.' + swiper.params.slideClass).length > 0 && swiper.$el.parents('.' + swiper.params.slideActiveClass).length === 0) {
                return undefined;
            }
            const swiperOffset = swiper.$el.offset();
            if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
            const swiperCoord = [
                [swiperOffset.left, swiperOffset.top],
                [swiperOffset.left + swiper.width, swiperOffset.top],
                [swiperOffset.left, swiperOffset.top + swiper.height],
                [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
            let i;
            for (i = 0; i < swiperCoord.length; i += 1) {
                const point = swiperCoord[i];
                if (
                    point[0] >= 0 && point[0] <= windowWidth &&
                    point[1] >= 0 && point[1] <= windowHeight
                ) {
                    inView = true;
                }
            }
            if (!inView) { return undefined; }
        }
        if (swiper.isHorizontal()) {
            if (kc === 37 || kc === 39) {
                if (e.preventDefault) { e.preventDefault(); } else { e.returnValue = false; }
            }
            if (kc === 39 && !rtl || kc === 37 && rtl) { Keyboard.doMove(swiper, -windowWidth * swiper.params.shortStepKeyboard.ratio); }
            if (kc === 37 && !rtl || kc === 39 && rtl) { Keyboard.doMove(swiper, windowWidth * swiper.params.shortStepKeyboard.ratio); }
        } else {
            if (kc === 38 || kc === 40) {
                if (e.preventDefault) { e.preventDefault(); } else { e.returnValue = false; }
            }
            if (kc === 40) { Keyboard.doMove(swiper, -windowHeight * swiper.params.shortStepKeyboard.ratio); }
            if (kc === 38) { Keyboard.doMove(swiper, windowHeight * swiper.params.shortStepKeyboard.ratio); }
        }
        swiper.emit('keyPress', kc);
        return undefined;
    },
    enable: function enable() {
        const swiper = this;
        if (swiper.shortStepKeyboard.enabled) { return; }
        doc.addEventListener('keydown', swiper.shortStepKeyboard.handle);
        swiper.shortStepKeyboard.enabled = true;
    },
    disable: function disable() {
        const swiper = this;
        if (!swiper.shortStepKeyboard.enabled) { return; }
        doc.addEventListener('keydown', swiper.shortStepKeyboard.handle);
        swiper.shortStepKeyboard.enabled = false;
    }
};

module.exports = {
    name: 'shortStepKeyboard',
    params: {
        shortStepKeyboard: {
            enabled: false,
            onlyInViewport: true,
            ratio: 0.9
        }
    },
    create: function create() {
        const swiper = this;
        Utils.extend(swiper, {
            shortStepKeyboard: {
                enabled: false,
                enable: Keyboard.enable.bind(swiper),
                disable: Keyboard.disable.bind(swiper),
                handle: Keyboard.handle.bind(swiper)
            }
        });
    },
    on: {
        init: function init() {
            const swiper = this;
            if (swiper.params.shortStepKeyboard.enabled) {
                swiper.shortStepKeyboard.enable();
            }
        },
        destroy: function destroy() {
            const swiper = this;
            if (swiper.shortStepKeyboard.enabled) {
                swiper.shortStepKeyboard.disable();
            }
        }
    }
};


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/components/SWShortStepKeyboard.js